<style lang="scss" src="./styles.scss" />

<template>

	<div class="lp-wrapper" :class="$store.state.mainFrame || $store.state.isMenuOpen ? 'main' : '' ">
		<div class="lp">

			<transition name="slide-left">

				<section class="section section--main slide-left" v-show="true || $store.state.mainFrame">
					<div class="section__inner">

						<div class="lp__body">
							<div class="lp__main-frame-wrapper">
								<div class="lp__main-frame" id="main-frame">
									<div class="lp__slogan">
										<span class="accent--gradient">
											Your
										</span>

										<span class="data-block" @mouseenter="showDataSources"
											@mouseleave="hideDataSources">
											<img src="../../assets/img/svg/data_text.svg" class="data-block__img" />

											<div class="data-block__sources" id="data-block__source">
												{{ currentDataSource }}
											</div>

										</span>
										<span class="dark-blue block">Can</span>
										<span class="accent--gradient">
											Cure You
										</span>
									</div>

									<div class="lp__main-info" id="scrollArea">
										<p>Track your health and predict severe diseases earlier with AI & Computer
											Vision</p>
										<div class="lp__more-info" v-if="!$store.state.isMobile">
											<a href="#0">Know
												how</a>
											<p>click here or scroll</p>
										</div>
										<div class="lp__more-info" v-if="$store.state.isMobile">
											<a href="#0">Discover</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<!-- </div> -->
			</transition>

			<transition name="slide-right">

				<section id="0" class="section section--second" :class="!$store.state.mainFrame ? 'slide-right' : ''">
					<div class="section__inner">

						<div class="two-column">
							<div class="two-column__column flex app-info">
								<div class="app-info__icons">
									<div v-for="(icon, i) in infoIcons" :key="i" class="info-icon"
										@mouseover="iconIsHover(i)" @mouseleave="iconNotHover(i)">
										<img :src="require(`@/assets/img/svg/${ isHovering ? icon.hoverImg : icon.img }`)"
											:alt="icon.alt" class="info-icon__img" />

										<svg class="rotation" xmlns="http://www.w3.org/2000/svg"
											xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200"
											viewBox="0 0 500 500">
											<path
												d="M50,250c0-110.5,89.5-200,200-200s200,89.5,200,200s-89.5,200-200,200S50,360.5,50,250"
												id="textcircle"></path>
											<text dy="0" textLength="1220">
												<textPath xlink:href="#textcircle">hover me - hover me - hover me -
												</textPath>
											</text>
										</svg>

										<transition name="fade">

											<div class="info-icon__text-block">
												<img :src="require(`@/assets/img/svg/${icon.backgroundImg}`)" />
												<p>{{ icon.text }}</p>
											</div>

										</transition>
									</div>
								</div>

								<p class="app-info__text">
									Using multiple sources, we pipe your bio data into our AI algorithms
									to analyze and predict the likelihood of severe diseases affecting your life,
									giving suggestions on how to prevent or reduce them
								</p>

								<button class="link link--outer">Learn more in our blog</button>
							</div>

							<div class="two-column__column app-screen">
								<img src="../../assets/img/testscreen.png" alt="app screen" />
							</div>

						</div>

						<div class="two-column">
							<div class="two-column__column two-column__column--left">
								<h2 class="h2">
									<span class="accent--gradient block">Your data </span>
									<span class="dark-blue">In a secure</span>
									<span class="accent--gradient"> BioBank</span>
								</h2>
								<p>Our app stores your health data in a secure vault by anonymizing
									and encrypting using latest available technologies and at same time
									easily allows you to share with your doctor only <a href="#" class="link">what you
										want</a>
								</p>
								<p>With our <a href="#" class="link">crypto rewards program</a> we can buy your
									anonimized data without strings attached</p>

								<div class="app-buttons">
									<a href="#" class="app-buttons__button">
										<img src="../../assets/img/svg/google.svg" />
									</a>
									<a href="#" class="app-buttons__button">
										<img src="../../assets/img/svg/apple.svg" />
									</a>
								</div>
							</div>

							<div class="two-column__column two-column__column--right app-screen">
								<img src="../../assets/img/testscreen2.png" alt="app screen" />
							</div>
						</div>
					</div>
				</section>

			</transition>

			<!-- make separate component for card -->

			<section class="section section--reviews">
				<div class="section__inner">

					<div class="reviews">
						<h3 class="h3 accent" :class="$store.state.isMobile ? ' ' : 'rotated'">What they say about us
						</h3>

						<carousel :items-to-show="1" class="cards" id="reviews">

							<slide v-for="(review, i) in reviews" :key="i">
								<div class="card">
									<!-- <h4 class="card__title"></h4> -->
									<p class="card__text dark-blue">{{ review.text }}</p>
									<div class="flex card__info">
										<div class="rating">
											{{ review.rating }}/5
										</div>
										<div class="author">
											{{ review.author }}
										</div>

									</div>
								</div>
							</slide>

							<template #addons>
								<navigation />
								<pagination />
							</template>
						</carousel>

						<button class="link go-right link--press">Press Articles</button>

						<button :class="goDownButton ? 'showButton' : 'hideButton'" class="link go-down"
							v-if="!$store.state.isMobile">Who even are We?</button>
					</div>
				</div>
			</section>

			<section class="section">
				<div class="section__inner">

					<div class="about" id="about">
						<h2 class="h2 dark-blue">
							Who <span class="accent--gradient">We</span> Are?
						</h2>

						<div class="text-block">
							<p><a href="#">Longevity InTime</a> is an AI & Big Data powered health company, providing
								real-time remote tracking technology for severe diseases at the earliest stages.
								Our goal is to prolong life for 20+ years by means of permanent measuring human biodata
								with more than 400 biomarkers, using your favorite weareable devices,
								manual input, lab tests and our BioContainer!
							</p>
						</div>

						<div class="flex link-group">
							<button class="link link--outer accent--gradient">
								BioContainer?
								<span>
									pre-order With discount!
								</span>
							</button>
							<button class="link link--outer">know More about Us</button>
						</div>
					</div>

				</div>
			</section>

			<section class="section section--accent">
				<div class="section__inner">

					<div class="team" id="team">
						<h2 class="h2 dark-blue">Team</h2>

						<div class="two-column">
							<div class="two-column__column">
								<p class="text-block">With 50+ developers, designers and leaders working from 12
									countries,
									we are the team with a mission of extending life
								</p>
								<p class="text-block">Want to join us? check out our <a
										class="link link--outer">careers</a></p>
							</div>
							<div class="two-column__column">
								<div class="members">
									<div v-for="(member, i) in teamMembers" :key="i" class="member"
										:class="member.active ? '' : 'tinted'" @click="showTeamMember(i, $event)"
										:style="{ top: `${member.coordinates.y}`, 
										 		   left:`${member.coordinates.x}`, 
												   width:`${member.size}px`, 
												   height:`${member.size}px` }">

										<img :src="require(`@/assets/img/${member.img}`)" />

										<div class="member__info">
											<button class="button button--close"
												@click="hideTeamMember($event)"></button>
											<div class="flex info">
												<img :src="require(`@/assets/img/${member.img}`)" class="info__img" />
												<p class="info__name">{{member.name}}</p>
											</div>
											<p class="info__text">
												{{member.text}}
											</p>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>

				</div>
			</section>

			<section class="section">
				<div class="section__inner">
					<h2 class="h2 dark-blue">What else we do</h2>

					<div class="ecosystem" id="ecosystem">

						<EcosystemChart :hierarchy="ecosystemChartData" id="ecosystemChart" />

					</div>

				</div>
			</section>

			<section class="section" v-if="0">
				<div class="section__inner">
					<h2 class="h2 dark-blue">Something to read & watch</h2>

					<div class="flex video-gallery">
						<Carousel v-show="!$store.state.isMobile" :items-to-show="1" class="videos videos--full"
							id="fullVideo" :wrap-around="true" :mouse-drag="false" :touchDrag="false"
							v-model="currentFullSlide">

							<Slide v-for="(video, i) in videos" :key="i">
								<div class="video">
									<iframe width="720" height="380" :src="video.link" :title="video.title"
										frameborder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
										allowfullscreen></iframe>
								</div>
							</Slide>
						</Carousel>

						<Carousel :items-to-show="1" class="videos videos--thumbnails" id="thumbnails"
							:wrap-around="true" :mouse-drag="false" :touchDrag="false" v-model="currentSlide"
							ref="carousel">

							<slide v-for="(video, i) in videos" :key="i">
								<div class="video" @click="slideTo(i)">
									<img :src="require(`@/assets/img/thumbnails/${video.image}`)"
										class="video__thumbnail" v-show="!$store.state.isMobile" />

									<iframe v-if="$store.state.isMobile" width="360" height="190" :src="video.link"
										:title="video.title" frameborder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
										allowfullscreen></iframe>
								</div>
							</slide>

							<template #addons>
								<div class="custom-pagination">
									<button class="custom-pagination__prev" @click="prev">Prev</button>
									<p>{{ currentSlide + 1 }} / {{ videos.length }} </p>
									<button class="custom-pagination__next" @click="next">Next</button>
								</div>
							</template>

						</Carousel>

					</div>
				</div>
			</section>

			<!-- <section class="section">
				<div class="section__inner" ref="target">

					<transition tag="div" name="books-falling" class="book-section" @enter="enter">
						<div v-if="bookSectionAnimate" class="animated-component">
							<div v-for="video in videos" :key="video.id" class="book">
								{{ video.title }}
							</div>
						</div>
					</transition>
					
				</div>
			</section> -->
		</div>
	</div>



	<MenuModal />


	<transition name="slide-right">

		<LangModal />

	</transition>
</template>

<script>
	import Header from '@/components/Header.vue'
	import MenuModal from '@/components/MenuModal.vue'
	import InputText from '@/components/input-text/InputText.vue'
	import RadioButton from '@/components/UIKit/RadioButton.vue'
	import LangModal from '@/components/LangModal.vue'
	import 'vue3-carousel/dist/carousel.css'
	import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
	import EcosystemChart from '@/components/EcosystemChart.vue'
	import ecosystemChartData from '../../assets/ecosystemChartData.json'
	// import d3ForceSurface from 'd3-force-surface'
	// import d3 from 'd3'
	import Velocity from 'velocity-animate'
	import { onMounted, ref } from 'vue'

	export default {
		name: 'LandingPageView',
		components: {
			Header,
			MenuModal,
			InputText,
			RadioButton,
			LangModal,
			Carousel,
			Slide,
			Pagination,
			Navigation,
			EcosystemChart,
			// d3ForceSurface
		},
		data() {
			return {
				// languages: ['English (US)', 'Russian'],
				dataSources: ['Biomarkers', 'Lab Test', 'Devices', 'Doctor Reports'],
				isMenuOpen: this.$store.state.isMenuOpen,
				languageBox: this.$store.state.languageBox,
				isHovering: false,
				isDataHovering: false,
				goDownButton: true,
				infoIcons: [
					{
						img: 'devices-icon.svg',
						hoverImg: 'devices-icon.svg',
						backgroundImg: 'devices-icon_hover.svg',
						alt: 'devices icon',
						text: 'Your journey start here, from your apps, devices and reports, we retrieve health data to be analyzed by AI'
					},
					{
						img: 'ai_icon.svg',
						hoverImg: 'ai_icon_hover.svg',
						backgroundImg: 'ai_icon.svg',
						alt: 'ai icon',
						text: `Here is where the magic happens! \n
We use Propietary & patented prediction algorithms trained with real world data. \n
They are the middle ground, where your data is analyzed to give you personalized suggestions`
					},
					{
						img: 'asterisk_icon.svg',
						hoverImg: 'asterisk_icon.svg',
						backgroundImg: 'asterisk_icon_hover.svg',
						alt: 'asterisk icon',
						text: `Suggestions are recalculated for every new update in your BioBank. \n
All of them are personalized, helping to make your health better while you get achievements and rewards for objectives`

					},
				],
				reviews: [
					{
						author: 'Jane Cooper',
						text: 'Cool App! Helps me achieve my daily goals and I get rewards as bonus',
						rating: 4,
						link: ''
					},
					{
						author: 'Jane Cooper',
						text: 'Cool App! Helps me achieve my daily goals and I get rewards as bonus',
						rating: 4,
						link: ''
					},
					{
						author: 'Jane Cooper',
						text: 'Cool App! Helps me achieve my daily goals and I get rewards as bonus',
						rating: 4,
						link: ''
					}
				],
				teamMembers: [
					{
						name: 'Oleg Teterin',
						img: 'team1.png',
						size: 128,
						coordinates: { x: '43%', y: '43%' },
						active: true,
						text: 'Produced award winning J. Favreau “Chef” (R.Downey Jr., S. Johansson) Advisor to News Outdoor $400M deal'
					},
					{
						name: 'Oleg Teterin',
						img: 'team2.png',
						size: 128,
						coordinates: { x: '70%', y: '20%' },
						active: true,
						text: 'Produced award winning J. Favreau “Chef” (R.Downey Jr., S. Johansson) Advisor to News Outdoor $400M deal'
					},
					{
						name: 'Oleg Teterin',
						img: 'team3.png',
						size: 96,
						coordinates: { x: '61%', y: '73%' },
						active: true,
						text: 'Produced award winning J. Favreau “Chef” (R.Downey Jr., S. Johansson) Advisor to News Outdoor $400M deal'
					},
					{
						name: 'Oleg Teterin',
						img: 'team4.png',
						size: 84,
						coordinates: { x: '20%', y: '20%' },
						active: true,
						text: 'Produced award winning J. Favreau “Chef” (R.Downey Jr., S. Johansson) Advisor to News Outdoor $400M deal'
					},
					{
						name: 'Oleg Teterin',
						img: 'team4.png',
						size: 84,
						coordinates: { x: '45%', y: '12%' },
						active: true,
						text: 'Produced award winning J. Favreau “Chef” (R.Downey Jr., S. Johansson) Advisor to News Outdoor $400M deal'
					},
					{
						name: 'Oleg Teterin',
						img: 'team3.png',
						size: 96,
						coordinates: { x: '19%', y: '55%' },
						active: true,
						text: 'Produced award winning J. Favreau “Chef” (R.Downey Jr., S. Johansson) Advisor to News Outdoor $400M deal'
					},
					{
						name: 'Oleg Teterin',
						img: 'team3.png',
						size: 96,
						coordinates: { x: '35%', y: '80%' },
						active: true,
						text: 'Produced award winning J. Favreau “Chef” (R.Downey Jr., S. Johansson) Advisor to News Outdoor $400M deal'
					},
					{
						name: 'Oleg Teterin',
						img: 'team4.png',
						size: 84,
						coordinates: { x: '83%', y: '55%' },
						active: true,
						text: 'Produced award winning J. Favreau “Chef” (R.Downey Jr., S. Johansson) Advisor to News Outdoor $400M deal'
					}
				],
				videos: [
					{
						id: 1,
						title: "Battle for Longevity (game) - coming soon",
						link: 'https://www.youtube.com/embed/D_hZcHNl-9A',
						image: 'th1.png'
					},
					{
						id: 2,
						title: 'Aubrey de Grey: Longevity, Aging, and Artificial Intelligence | USIA Podcast #7',
						link: 'https://www.youtube.com/embed/xQytP22d3sA',
						image: 'th2.jpg'
					},
					{
						id: 3,
						title: 'Reverse Aging | Dr. Shai Efrati | TEDxWhiteCity',
						link: 'https://www.youtube.com/embed/1TEYTNI9UEo',
						image: 'th3.jpg'
					},
					{
						id: 4,
						title: 'How to die young at a very old age | Nir Barzilai | TEDxGramercy',
						link: 'https://www.youtube.com/embed/TsA4SHhUzt4',
						image: 'th4.jpg'
					},
					{
						id: 5,
						title: 'Reverse Aging | Dr. Shai Efrati | TEDxWhiteCity',
						link: 'https://www.youtube.com/embed/1TEYTNI9UEo',
						image: 'th5.jpg'
					},
					{
						id: 6,
						title: 'Reverse Aging | Dr. Shai Efrati | TEDxWhiteCity',
						link: 'https://www.youtube.com/embed/1TEYTNI9UEo',
						image: 'th6.jpg'
					},
					{
						id: 7,
						title: 'Reverse Aging | Dr. Shai Efrati | TEDxWhiteCity',
						link: 'https://www.youtube.com/embed/1TEYTNI9UEo',
						image: 'th7.jpg'
					},
					{
						id: 8,
						title: 'Reverse Aging | Dr. Shai Efrati | TEDxWhiteCity',
						link: 'https://www.youtube.com/embed/1TEYTNI9UEo',
						image: 'th8.jpg'
					}
				],
				ecosystemChartData: ecosystemChartData,
				dataSourcesCounter: 0,
				interval: undefined,
				currentDataSource: '',
				currentSlide: 0,
				currentFullSlide: 0,
				isMobile: this.$store.state.isMobile
			}
		},
		beforeMount() {
			let isMobile = (window.innerWidth < 768 ? true : false)

			this.$store.commit('switchIsMobile', isMobile)
		},
		mounted() {
			document.getElementById('scrollArea').addEventListener('scroll', this.handleScroll)
			window.addEventListener('scroll', this.pageHandleScroll)

			window.addEventListener('resize', this.onResize)

		},
		updated() {
			if (!this.$store.state.mainFrame) {
				this.hoverEffect()
			}
		},
		destroyed() {
			document.getElementById('scrollArea').removeEventListener('scroll', this.handleScroll)
			window.removeEventListener('scroll', this.pageHandleScroll)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.onResize)
		},

		methods: {
			handleScroll(event) {
				this.slideLeft = true
			},

			pageHandleScroll() {
				let buttonPos = document.getElementById("about").offsetTop

				if (window.scrollY >= buttonPos - 800) {
					this.goDownButton = false
				} else {
					this.goDownButton = true
				}
			},

			onResize() {
				let isMobile = (window.innerWidth < 768 ? true : false)

				this.$store.commit('switchIsMobile', isMobile)
			},

			switchLangBox() {
				this.$store.commit('switchLangBox', !this.$store.state.languageBox)
			},
			switchMainFrame() {
				this.$store.commit('switchMainFrame', !this.$store.state.mainFrame)
			},

			iconIsHover(i) {
				this.isHovering = true

				let iconsArr = []
				iconsArr = document.getElementsByClassName('info-icon')

				for (let j = 0; j < iconsArr.length; j++) {
					iconsArr[j].classList.remove('active')
				}
				iconsArr[i].classList.add('hovered')
				if (i < 2) {
					iconsArr[i + 1].classList.add('active')
				} else {
					i = 0
					iconsArr[i].classList.add('active')
				}

			},

			iconNotHover(i) {
				this.isHovering = false

				let iconsArr = []
				iconsArr = document.getElementsByClassName('info-icon')

				if (iconsArr[i].classList.contains('hovered')) {
					iconsArr[i].classList.remove('hovered')
				} else if (i < 2) {
					iconsArr[i + 1].classList.add('active')
				} else if (i >= 2) {
					i = 0
					iconsArr[i].classList.add('active')
				}

			},

			hoverEffect() {
				let iconsArr = []
				iconsArr = document.getElementsByClassName('info-icon')

				for (let i = 0; i < iconsArr.length; i++) {
					hoverMe(iconsArr[i], iconsArr[i - 1], i * 8500)
				}

				function hoverMe(item, prevItem, delay) {
					setTimeout(() => {
						item.classList.add('active')
						if (prevItem != undefined) {
							prevItem.classList.remove('active')
						}
					}, delay)
				}
			},

			count() {

				if (this.dataSourcesCounter >= this.dataSources.length) {
					this.dataSourcesCounter = 0
				} else if (this.isDataHovering) {
					this.currentDataSource = this.dataSources[this.dataSourcesCounter]

					this.dataSourcesCounter++

				} else {
					this.currentDataSource = ''
				}

			},
			showDataSources() {

				this.isDataHovering = true

				this.interval = setInterval(this.count, 1000)
			},
			hideDataSources() {

				this.isDataHovering = false

				this.interval = clearInterval(this.interval)

				this.currentDataSource = ''
			},

			showTeamMember(i, e) {
				return
				this.teamMembers.forEach(el => el.active = false)
				this.teamMembers[i].active = true
				e.target.nextSibling.style.left = '0%'
			},

			hideTeamMember(e) {
				e.target.parentElement.style.left = '-200%'
			},

			slideTo(val) {
				this.currentFullSlide = val
			},
			next() {
				this.currentSlide++
			},
			prev() {
				this.currentSlide--
			}
		}
	}
</script>